module.exports = __webpack_public_path__ + "img/ueber-uns-main-v2.4dd36e1b.jpg";